import { useEffect, useState } from 'react';
import { dashboardService } from '../services';
import type { DailyChartPoint } from '../services/dashboardService';
import { getApiErrorMessage } from '../lib/apiError';

export type ChartDays = 7 | 30;

/** Loads the daily SMS chart for the chosen window and reloads when it changes. */
export function useDailyChart(initialDays: ChartDays = 7) {
  const [days, setDays] = useState<ChartDays>(initialDays);
  const [data, setData] = useState<DailyChartPoint[]>([]);
  // Starts true so the first paint shows the skeleton, not "No data".
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    // Ignore a slow response for a window the user has already switched away from.
    let stale = false;
    setLoading(true);
    setError(null);
    dashboardService
      .getDailyChart(days)
      .then((points) => {
        if (!stale) setData(points);
      })
      .catch((err) => {
        if (!stale) setError(getApiErrorMessage(err, 'Could not load the daily chart'));
      })
      .finally(() => {
        if (!stale) setLoading(false);
      });
    return () => {
      stale = true;
    };
  }, [days]);

  return { days, setDays, data, loading, error };
}
